export class DetailsMapConstants {
  public static readonly MAXIMUM_MARKERS = 10;
}
